import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  detachOneServerData: {},
  addOneServerData: {},
  editOneServerData: {},
  deleteOneServerData: {},
  attachOneServerData: {},
  oneServerData: [],
};

const oneServerSlice = createSlice({
  name: 'oneServer',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = null;
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    setAllOneServers: (state, action) => {
      state.oneServerData = action.payload;
      state.isLoading = false;
    },
    setAddOneServers: (state, action) => {
      state.addOneServerData = action.payload;
      state.isLoading = false;
    },
    setEditOneServers: (state, action) => {
      state.editOneServerData = action.payload;
      state.isLoading = false;
    },
    setDeleteOneServers: (state, action) => {
      state.deleteOneServerData = action.payload;
      state.isLoading = false;
    },
    setAttachOneServers: (state, action) => {
      state.attachOneServerData = action.payload;
      state.isLoading = false;
    },
    setDetachOneServers: (state, action) => {
      state.detachOneServerData = action.payload;
      state.isLoading = false;
    },
    setResetOneServer: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllOneServers,
  setAddOneServers,
  setEditOneServers,
  setDeleteOneServers,
  setAttachOneServers,
  setDetachOneServers,
  setResetOneServer,
} = oneServerSlice.actions;

export default oneServerSlice.reducer;
